import React from 'react'
import styled from 'styled-components'
import Asset from '../../../components/asset/Asset'
import { IAssetData } from '../../../helpers/data/assetData'

const Wrapper = styled.div`
	width: 372px;
	height: 700px;
	margin-left: 140px;
`

interface ICelebrationProps {
	celebration: IAssetData[]
}

class Celebration extends React.PureComponent<ICelebrationProps> {
	render() {
		const rnd = Math.floor(Math.random() * this.props.celebration.length)

		return (
			<Wrapper>
				<Asset asset={this.props.celebration[rnd]} />
			</Wrapper>
		)
	}
}

export default Celebration
